/*
 * Paths that should not be included in the sitemap and have noindex meta tag
 * Wildcard matching, i.e. /confirmation will match both /confirmation and /become-a-partner/confirmation and any path with language prefix, i.e. /en/confirmation
 */
export const HIDDEN_PAGES_INCLUDES = [
  '/auth',
  '/free-trial',
  '/friend/request',
  '/email-verification',
  '/checkout',
  '/confirmation',
  '/classes',
  '/gift-card/', // Trailing slash to match gift card id page but not the gift card explore page
  '/studio-faq',
  '/partner/signup',
] as const

export const EXCLUDE_ROUTE_PATTERNS = HIDDEN_PAGES_INCLUDES.map(
  (hiddenPath) => `.*${hiddenPath}.*`,
)
